var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import * as Amplitude from '@amplitude/analytics-browser';
import { useCallback } from 'react';
import { assertCanHandle } from '@lucidlink/tscore';
import { isAmplitudeStarted } from '#integrations';
export const useReporting = () => {
    _react_refresh_temp_1();
    const reportEvent = useCallback(({ name, params, ...rest }) => {
        // Amplitude queues events tracked before init() and would send them once the user consents
        if (!isAmplitudeStarted()) {
            return;
        }
        const amplitudeParams = !params
            ? {
                ...rest,
            }
            : {
                ...params,
                ...rest,
            };
        void (async () => {
            try {
                await Amplitude.track(name, amplitudeParams).promise;
            }
            catch (error) {
                assertCanHandle(error, () => true);
            }
        })();
    }, []);
    return {
        reportEvent,
    };
};
_react_refresh_temp_1(useReporting, "dnp8mS1ufgF9K5xyoqkbzvXKIfQ=");
